import { render, staticRenderFns } from "./AssignedCreditors.vue?vue&type=template&id=806771ac&scoped=true"
import script from "./AssignedCreditors.vue?vue&type=script&lang=js"
export * from "./AssignedCreditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806771ac",
  null
  
)

export default component.exports